/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_CopiedInputs */

const en_tut_copied = /** @type {(inputs: Tut_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const id_tut_copied = /** @type {(inputs: Tut_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersalin`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Tut_CopiedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_copied = /** @type {((inputs?: Tut_CopiedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_CopiedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_copied(inputs)
	return en_tut_copied(inputs)
});